export const az = {
  title: 'Tropik ağac örtüyü',
  subtitle: '2020, 10 m/0.5 ha, tropical, WRI',
  download_data: 'https://data.globalforestwatch.org/datasets/tropical-tree-cover/explore',
  learn_more: '',
  content: [
    {
      label: 'Funksiya',
      value:
        'Şəhər yerlərində, kənd təsərrüfatı torpaqlarında ağacların dəqiq monitorinqini, açıq kanopiya və quru meşə ekosistemlərində ağacların düzgün monitorinqini təmin etmək üçün yarım hektar şkalada ağac miqyasını və ağac örtüyüni nümayiş etdirir',
    },
    {
      label: 'Qətmə',
      value: '10 x 10 metr, yarım hektar',
    },
    {
      label: 'Coğrafi əhatə',
      value: 'tropiklərin 4,3 milyard hektarı (-23,44-23,44 enlik)',
    },
    {
      label: 'Mənbə',
      value: 'World Resources Institute',
    },
    {
      label: 'Tezlik',
      value:
        '2017-ci ildən başlayaraq illik dəyişiklik aşkarlama xəritələri 2024-cü ilin buraxılışı üçün planlaşdırılır.',
    },
    {
      label: 'Məzmun tarixi',
      value: '2020',
    },
    {
      label: 'Xəbərdarlıqlar',
      value:
        'Bu datasetdə ağacın fərqli tərifi və ağac örtüyünün fərqli tərifi Hansen et al. (2013) ilə müqayisədə istifadə olunur. Bu dataset ağacı həm hündürlüyə, həm də tac diametrinə görə təyin edir. Tac diametrindən asılı olmayaraq 5 metrdən yüksək olan və ya minimum tac diametri 5 metr olan 3-5 metr arasında olan vudi bitki örtüyü ağac hesab olunur. Bu tərif Hansen et al. (2013) ilə fərqlənir ki, bir ağac ən azı 5 metr hündürlüyündə hər hansı bitki kimi müəyyən edir. Tropik ağac örtüyü dataset bitki olmayan ağaclardan plantasiya ağaclarını disambiqasiya etmir.\n\n0,5 ha-dan kiçik olan şaftalılar üçün alınan analizlər və ya statistik məlumatlar dəqiq olmaya bilər.',
    },
    {
      label: 'Lisenziya',
      value: 'CC 4.0',
    },
  ],
  overview: {
    label: 'Ümumi baxış',
    value:
      'Tropik ağac onmetrlik şkalada ağac miqyasını, ağac örtüyü isə yarım hektarlıq şkalada əhatə edir ki, bu da şəhər yerlərində, kənd təsərrüfatı torpaqlarında, eləcə də açıq kanopiya və quru meşə ekosistemlərində ağacların dəqiq monitorinqini təmin edir. Bu məlumatlar qlobal tropiklərin 4,3 milyard hektardan çox hissəsini əhatə edir.\n\nVerilənlər Sentinel optik və radar şəkillərinə tətbiq edilən çoxvaylı konvolutional neyron şəbəkə modellərindən əldə edilmişdir. 10 metrlik dataset torpaq örtüyü xəritəsinə bənzər ikili ağac ölçüsü təbəqəsidir, ağac örtüyü məlumatları isə yarım hektar şkalada fraksiyalı örtüyü təmsil edir. Metodika və analizlər haqqında daha ətraflı məlumatı GitHub səhifəsindən əldə edə bilərsiniz.',
  },
  citation: {
    label: 'Sitat',
    value:
      'Use the following credit when this data is displayed: Source: 14/02/2025, accessed through Global Forest Watch on 14/02/2025\n\nUse the following credit when this data is cited: Brandt,\nBrandt, J., Ertel, J., Spore, J., & Stolle, F. (2023). WALL-to-wall\nmapping of tree extent in the tropics with sentinel-1 and sentinel-2. Remote Sensing of Environment, 292, 113574. https://doi.org/10.1016/j.rse.2023.11357',
  },
};
